import { PREFIX } from "./storage-keys";

const clearAppLocalStorage = () => {
  for (const key of Object.keys(localStorage)) {
    if (key.startsWith(PREFIX)) {
      localStorage.removeItem(key);
    }
  }
};

export const resetAllStorage = () => {
  clearAppLocalStorage();
  sessionStorage.clear();

  const url = new URL("/", window.location.origin);
  url.searchParams.set("reset", Date.now().toString());
  window.location.replace(url.toString());
};
